import Button from '@cartwhl/ui/input/Button';

export function VerticalNavButtons({
  disablePrev,
  disableNext,
  onPrev,
  onNext,
  className,
}: {
  disablePrev?: boolean;
  disableNext?: boolean;
  onPrev?: () => void;
  onNext?: () => void;
  className?: string;
}) {
  return (
    <div className={`hidden gap-2 lg:flex ${className ?? ''}`}>
      <Button
        variant="secondary"
        disabled={disablePrev}
        onClick={onPrev}
        icon={<ArrowRightIcon className="rotate-180" />}
      />
      <Button
        variant="secondary"
        disabled={disableNext}
        onClick={onNext}
        icon={<ArrowRightIcon />}
      />
    </div>
  );
}

const ArrowRightIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.8442 9.99854C17.8442 10.2586 17.7474 10.4855 17.5537 10.6792L12.0752 16.1411C11.8815 16.3293 11.6629 16.4233 11.4194 16.4233C11.1649 16.4233 10.9518 16.3403 10.7803 16.1743C10.6143 16.0083 10.5312 15.8008 10.5312 15.5518C10.5312 15.4245 10.5534 15.3055 10.5977 15.1948C10.6475 15.0841 10.7139 14.9873 10.7969 14.9043L12.6562 13.0283L15.7524 10.2061L16.043 10.7373L13.1626 10.9033H3.07715C2.80046 10.9033 2.57633 10.8203 2.40479 10.6543C2.23877 10.4827 2.15576 10.2642 2.15576 9.99854C2.15576 9.72738 2.23877 9.50879 2.40479 9.34277C2.57633 9.17122 2.80046 9.08545 3.07715 9.08545H13.1626L16.043 9.25977L15.7524 9.79932L12.6562 6.96875L10.7969 5.08447C10.7139 5.00146 10.6475 4.90739 10.5977 4.80225C10.5534 4.69157 10.5312 4.56982 10.5312 4.43701C10.5312 4.18799 10.6143 3.98047 10.7803 3.81445C10.9518 3.64844 11.1649 3.56543 11.4194 3.56543C11.5412 3.56543 11.6574 3.59033 11.7681 3.64014C11.8787 3.68994 11.9839 3.76465 12.0835 3.86426L17.5537 9.31787C17.7474 9.51156 17.8442 9.73844 17.8442 9.99854Z"
        fill="currentColor"
      />
    </svg>
  );
};
